import { render, staticRenderFns } from "./NavDesktopProductsColumn.vue?vue&type=template&id=457a4139&scoped=true"
import script from "./NavDesktopProductsColumn.vue?vue&type=script&lang=js"
export * from "./NavDesktopProductsColumn.vue?vue&type=script&lang=js"
import style0 from "./NavDesktopProductsColumn.vue?vue&type=style&index=0&id=457a4139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a4139",
  null
  
)

export default component.exports